module.exports = __webpack_public_path__ + "static/media/home-gray.e5e849a2.svg";